const creditData = [
  {
    id: 1,
    image:
      "https://images.unsplash.com/photo-1613243555988-441166d4d6fd?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8dmlzYSUyMGNhcmR8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60",
    title: "You want to see your credit score for free...",
    text: "But that is just the start!",
  },
  {
    id: 2,
    image:
      "https://images.unsplash.com/photo-1613243555978-636c48dc653c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTF8fHZpc2ElMjBjYXJkfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
    title: "Check your offers...",
    text: "Insurance, credit cards, wifis and so on!",
  },
  {
    id: 3,
    image:
      "https://images.unsplash.com/photo-1634128222187-18eababc763d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Nnx8Y3JlZGl0JTIwc2NvcmV8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60",
    title: "Explore and see what do you qualify for...",
    text: "See loans selected for you!",
  },
  {
    id: 4,
    image:
      "https://images.unsplash.com/photo-1560520653-9e0e4c89eb11?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NXx8Y3JlZGl0JTIwc2NvcmV8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60",
    title: "Affordability calculator...",
    text: "See what adjustments you can make!",
},
  {
    id: 5,
    image:
      "https://images.unsplash.com/photo-1620714223084-8fcacc6dfd8d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8Y3JlZGl0JTIwc2NvcmV8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60",
    title: "Check short term debt...",
    text: "Check long term debt!",
   
  },
];

export default creditData;
